import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import config from '../../../../../../../../../config'
import ToggleButton from '../../../../../../../../../components/ToggleButton'
import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import Turnover from './components/graphs/Turnover'
import Employees from './components/graphs/Employees'
import Profit from './components/graphs/Profit'
import Capital from './components/graphs/Capital'
import DataTable from './components/DataTable'
import ProfitDataTable from './components/ProfitDataTable'

import { isDataNotEmpty, isProfitNotEmpty, isCapitalNotEmpty } from './helpers'
import { LOCALE_PREFIX } from './constants'
import hocConnect from './hocConnect'
import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@hocConnect
@injectIntl
export default class Velikost extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        id: PropTypes.string.isRequired,
        data: PropTypes.object,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        showCapitalTable: PropTypes.bool,
        showEmployeeTable: PropTypes.bool,
        showProfitTable: PropTypes.bool,
        showTurnoverTable: PropTypes.bool,
        sizeChangeShowTable: PropTypes.func.isRequired,
        transformedData: PropTypes.object,
    }

    static defaultProps = {
        showCapitalTable: false,
        showEmployeeTable: false,
        showProfitTable: false,
        showTurnoverTable: false,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.module !== nextProps.module) return true
        if (this.props.block !== nextProps.block) return true
        if (this.props.showCapitalTable !== nextProps.showCapitalTable) return true
        if (this.props.showEmployeeTable !== nextProps.showEmployeeTable) return true
        if (this.props.showProfitTable !== nextProps.showProfitTable) return true
        if (this.props.showTurnoverTable !== nextProps.showTurnoverTable) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    handleToggleDataTable = (checked, valueName) => {
        const { module, id, block, customData, sizeChangeShowTable } = this.props

        const newCustomData = {
            ...customData,
            [valueName]: checked,
        }

        sizeChangeShowTable(module, id, block, newCustomData)
    }

    render() {
        const {
            id,
            intl,
            data,
            transformedData,
            showProfitTable,
            showCapitalTable,
            showTurnoverTable,
            showEmployeeTable,
        } = this.props

        return (
            <div className={cx('block-size')}>
                <div className="graphs-container">
                    <div className="graph-block">
                        <div className="graph-block-title">
                            <FormattedMessage id={`${LOCALE_PREFIX}.turnover`} />
                        </div>
                        <div className="graph-wrapper">
                            <div className="header-row">
                                <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                                <ToggleButton
                                    active={showTurnoverTable}
                                    disabled={_.isEmpty(_.get(transformedData, 'turnover', null))}
                                    textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.no` })}
                                    textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` })}
                                    onClickHandler={(e) => this.handleToggleDataTable(e, 'showTurnoverTable')}
                                    inactiveGreyBackground
                                    inactiveGreyBorder
                                />
                            </div>
                            {!_.isEmpty(_.get(transformedData, 'turnover')) && isDataNotEmpty(data?.turnover) ? (
                                <div className="graph-row">
                                    <Turnover data={_.get(transformedData, 'turnover', [])} />
                                </div>
                            ) : (
                                <div className={'filler-row'} />
                            )}
                            {!_.isEmpty(_.get(transformedData, 'turnover')) && showTurnoverTable && (
                                <div className="data-table-row">
                                    <DataTable
                                        id={id}
                                        type={'turnover'}
                                        data={_.get(transformedData, 'turnover', [])}
                                    />
                                </div>
                            )}
                            <div className={'missing-graph-data-msg'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.missingGraphData`} />
                            </div>
                        </div>
                    </div>
                    <div className="graph-block">
                        <div className="graph-block-title">
                            <FormattedMessage id={`${LOCALE_PREFIX}.numberOfEmployees`} />
                        </div>
                        <div className="graph-wrapper">
                            <div className="header-row">
                                <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                                <ToggleButton
                                    active={showEmployeeTable}
                                    disabled={_.isEmpty(_.get(transformedData, 'employee', null))}
                                    textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.no` })}
                                    textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` })}
                                    onClickHandler={(e) => this.handleToggleDataTable(e, 'showEmployeeTable')}
                                    inactiveGreyBackground
                                    inactiveGreyBorder
                                />
                            </div>
                            {!_.isEmpty(_.get(transformedData, 'employee')) && isDataNotEmpty(data?.employee) ? (
                                <div className="graph-row">
                                    <Employees data={_.get(transformedData, 'employee', [])} />
                                </div>
                            ) : (
                                <div className={'filler-row'} />
                            )}
                            {!_.isEmpty(_.get(transformedData, 'employee')) && showEmployeeTable && (
                                <div className="data-table-row">
                                    <DataTable
                                        id={id}
                                        type={'employee'}
                                        data={_.get(transformedData, 'employee', [])}
                                    />
                                </div>
                            )}
                            <div className={'missing-graph-data-msg'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.missingGraphData`} />
                            </div>
                        </div>
                    </div>
                    <div className="graph-block">
                        <div className="graph-block-title">
                            <FormattedMessage id={`${LOCALE_PREFIX}.profit`} />
                        </div>
                        <div className="graph-wrapper">
                            <div className="header-row">
                                <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                                <ToggleButton
                                    active={showProfitTable}
                                    disabled={_.isEmpty(_.get(transformedData, 'profit', null))}
                                    textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.no` })}
                                    textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` })}
                                    onClickHandler={(e) => this.handleToggleDataTable(e, 'showProfitTable')}
                                    inactiveGreyBackground
                                    inactiveGreyBorder
                                />
                            </div>
                            {!_.isEmpty(_.get(transformedData, 'profit')) && isProfitNotEmpty(data?.profit) ? (
                                <div className="graph-row">
                                    <Profit data={_.get(transformedData, 'profit', [])} />
                                </div>
                            ) : (
                                <div className={'filler-row'} />
                            )}
                            {!_.isEmpty(_.get(transformedData, 'profit')) && showProfitTable && (
                                <div className="data-table-row">
                                    <ProfitDataTable
                                        id={id}
                                        type={'profit'}
                                        data={_.get(transformedData, 'profit', [])}
                                    />
                                </div>
                            )}
                            <div className={'missing-graph-data-msg'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.missingGraphData`} />
                            </div>
                        </div>
                    </div>
                    <div className="graph-block">
                        <div className="graph-block-title">
                            <FormattedMessage id={`${LOCALE_PREFIX}.capital`} />
                        </div>
                        <div className="graph-wrapper">
                            <div className="header-row">
                                <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                                <ToggleButton
                                    active={showCapitalTable}
                                    disabled={_.isEmpty(_.get(transformedData, 'capital', null))}
                                    textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.no` })}
                                    textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` })}
                                    onClickHandler={(e) => this.handleToggleDataTable(e, 'showCapitalTable')}
                                    inactiveGreyBackground
                                    inactiveGreyBorder
                                />
                            </div>
                            {!_.isEmpty(_.get(transformedData, 'capital')) && isCapitalNotEmpty(data?.capital) ? (
                                <div className="graph-row">
                                    <Capital data={_.get(transformedData, 'capital', [])} />
                                </div>
                            ) : (
                                <div className={'filler-row'} />
                            )}
                            {!_.isEmpty(_.get(transformedData, 'capital')) && showCapitalTable && (
                                <div className="data-table-row">
                                    <DataTable id={id} type={'capital'} data={_.get(transformedData, 'capital', [])} />
                                </div>
                            )}
                            <div className={'missing-graph-data-msg'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.missingGraphData`} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
